import { Component } from '@nicolas-riciotti/light2';
import {isMobilePortrait} from '../../helpers/isMobile';
import Lenis from '../../helpers/Lenis'
import getPosition from '../../helpers/getPosition';
import BezierEasing from '../../helpers/BezierEasing.js'

const easing = BezierEasing(.43,.195,.02,1);

const SPREAD_X = 0.4; // <1 pushes EDGE-anchored slides closer to viewport edges
const SPREAD_X_THRESHOLD = 25; // only spread slides whose left/right anchor is below this (vmax); keeps center-positioned slides where the editor placed them
const SLIDE_SCALE = 0.5; // shrinks all slide widths by this factor
const MAX_BLUR_PX = 14;

export default class BlockPortal extends Component {

    created() {
        this.angle = 0;
        this.siteSettingsMotionChange = this.siteSettingsMotionChange.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this._scroll   = 0;
        this._slideState = [];
        this._lastContentOpacity = -1;
        this._lastContentPE = '';
        this._cachedPos = null;
    }

    resize() {
        this.totalScrollHeight = (window.innerHeight*0.3) * this.$slides.length  ;

        this.$slidescontainer.style.perspective = '250dvh';
        this._cachedPos = getPosition(this);
    }

    siteSettingsMotionChange(event) {
        this.stopped = ('off' === event.detail)
    }

    detached() {
        document.removeEventListener('site_settings_motion', this.siteSettingsMotionChange);
    }

    attached() {

        document.addEventListener('site_settings_motion', this.siteSettingsMotionChange, false)
        this.$slidescontainer = this.querySelector('[data-slides-container]');
        this.$contentContainer = this.querySelector('[data-content-container]');
        this.$slides = this.querySelectorAll('[data-slide]');

        this.$slides.forEach((slideEl) => {
            slideEl.style.willChange = 'transform, opacity, filter';
            const inline = slideEl.style;
            ['left', 'right'].forEach((side) => {
                const raw = inline[side];
                if (!raw) return;
                const match = raw.match(/^(-?[\d.]+)(vmax|vw|vh|px|%)$/);
                if (!match) return;
                const value = parseFloat(match[1]);
                // Only push edge-anchored slides toward edges; leave center-ish slides alone
                if (value >= SPREAD_X_THRESHOLD) return;
                inline[side] = (value * SPREAD_X) + match[2];
            });
            if (inline.width) {
                const widthMatch = inline.width.match(/^(-?[\d.]+)(vmax|vw|vh|px|%|rem|em)$/);
                if (widthMatch) {
                    inline.width = (parseFloat(widthMatch[1]) * SLIDE_SCALE) + widthMatch[2];
                }
            }
            this._slideState.push({ z: NaN, opacity: -1, blur: -1 });
        });

        this.resize();
        Lenis?.on?.('scroll', this.onScroll)


        this.intersectionObserver = new IntersectionObserver((entries)=>{
            if (window.innerWidth <= 600) {
                entries.forEach((el)=>{
                    if (el.isIntersecting) {
                        el.target.classList.add('in-view')
                    }
                    else {
                        el.target.classList.remove('in-view')
                    }
                });
            }
        });
        this.intersectionObserver.observe(this);

    }

    onScroll(e) {

        this._scroll = e.animatedScroll ;

        this.introScroll  = 0// (1 - this.introProgresss) * ((window.innerHeight ) );

        if (window.innerWidth <= 600 || this.stopped) {

            this.style.paddingTop  = '0px';
            this.$contentContainer.style.pointerEvents = 'auto';
            this.$contentContainer.style.position = 'relative'
            this.$contentContainer.style.opacity = 1;

        }
        else {

            this.$contentContainer.style.position = 'fixed';
            this.style.paddingTop  = this.totalScrollHeight + 'px';

            const pos = this._cachedPos || getPosition(this);
            const start = (pos.top - (window.innerHeight * 0.5));
            const vh = window.innerHeight;
            this.$slides?.forEach((slideEl, slideIndex) => {
                const diff = Math.min(1, Math.max(0, this._scroll - start - slideIndex * vh * 0.2) / vh);
                const state = this._slideState[slideIndex];
                if (this.stopped) {
                    if (state.opacity !== 0) {
                        slideEl.style.opacity = 0;
                        state.opacity = 0;
                    }
                }
                else {
                    
                    const fadeInEnd = 0.5;
                    const fadeOutStart = 0.82;

                    let opacityValue = 1;

                    if (diff <= fadeInEnd) {
                        opacityValue = diff / fadeInEnd;
                    }
                    else if (diff >= fadeOutStart) {
                        opacityValue = 1 - ((diff - fadeOutStart) / (1 - fadeOutStart));
                    }

                    opacityValue = Math.min(1, Math.max(0, opacityValue));

                    // Z range -300..50 keeps slides smaller than perspective (no exploding scale)
                    const zValue = -300 + diff * 350;

                    const distanceFromSharpPoint = Math.abs(diff - fadeInEnd) / fadeInEnd;
                    const blurValue = MAX_BLUR_PX * Math.min(1, distanceFromSharpPoint);

                    if (zValue !== state.z) {
                        slideEl.style.transform = `translate3d(0,0,${zValue}vh)`;
                        state.z = zValue;
                    }
                    if (opacityValue !== state.opacity) {
                        slideEl.style.opacity = opacityValue;
                        state.opacity = opacityValue;
                    }
                    if (blurValue !== state.blur) {
                        slideEl.style.filter = blurValue === 0 ? '' : `blur(${blurValue}px)`;
                        state.blur = blurValue;
                    }
                }
            });

            let r = 0;
            if ( (this._scroll - ((pos.top )))  < (this.totalScrollHeight - vh * 0.75) ) {
                r =  Math.min(1, Math.max(0, (this._scroll - ((pos.top))) / (vh * 0.5)) );
                r = easing(r);
            }
            else {
                const diff =  (this._scroll - pos.top)  - (this.totalScrollHeight -( vh * 0.75));
                r =  1 - Math.min(1, Math.max(0, diff /  (vh * 0.25) ) );
            }
            const targetOpacity = this.stopped ? (r > 0 ? 1 : 0) : r;
            // if (targetOpacity !== this._lastContentOpacity) {
                this.$contentContainer.style.opacity = targetOpacity;
                // this._lastContentOpacity = targetOpacity;
            // }

            const targetPE = r > 0 ? 'auto' : 'none';
            if (targetPE !== this._lastContentPE) {
                this.$contentContainer.style.pointerEvents = targetPE;
                this._lastContentPE = targetPE;
            }
            
            this.classList[r > 0 ? 'add' : 'remove']('in-view');

        }


    }

    update() {

    }

}

customElements.define('block-portal', BlockPortal);